import http from '@/http'
import authHeader from './auth-header'

class AgendamentoService {
  async get() {
    const response = await http.get('calendario', { headers: authHeader() })
    return response.data.reverse()
  }

  async getAgendamento(year) {
    const response = await http.get('agendamento', {
      headers: authHeader(),
      params: year ? { year } : undefined,
    })

    return response.data.reverse()
  }

  async getAgendamentoYears() {
    const response = await http.get('agendamento', {
      headers: authHeader(),
      params: { years: 1 },
    })

    return response.data?.years || []
  }

  async downloadAgendamentosExcel(year) {
    return http.get(`agendamento/excel/${year}`, {
      headers: authHeader(),
      responseType: 'blob',
    })
  }

  async getComprovante(key) {
    const response = await http.post(
      `agendamento/comprovante`,
      {
        key,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async createManualScheduling(payload) {
    const response = await http.post('agendamento/adm/novo', payload, {
      headers: authHeader(),
    })

    return response.data
  }

  async createDeleteSchedulingPin(idScheduling) {
    const response = await http.post(
      `agendamento/adm/excluir/${idScheduling}/pin`,
      {},
      { headers: authHeader() },
    )

    return response.data
  }

  async deleteScheduling({
    idScheduling,
    pin,
    confirmationToken,
    confirmDelete,
  }) {
    const response = await http.delete(
      `agendamento/adm/excluir/${idScheduling}`,
      {
        headers: authHeader(),
        data: {
          pin,
          confirmationToken,
          confirmDelete,
        },
      },
    )

    return response.data
  }

  async getById(id) {
    const response = await http.get(`agendamento/${id}`, {
      headers: authHeader(),
    })
    return response.data
  }

  async delete(id) {
    const response = await http.delete(`calendario/remover/${id}`, {
      headers: authHeader(),
    })
    return response.data
  }

  async post({ date, total, type, status }) {
    const response = await http.post(
      'calendario/novo',
      {
        date,
        total,
        type,
        status,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async put({ type, status, total, idCalendar }) {
    const response = await http.put(
      `/calendario/atualizar/${idCalendar}`,
      {
        type,
        total,
        status,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async atualizaAgendamentoStatus({
    status,
    noteCorrection,
    inputsCorrection,
    idScheduling,
  }) {
    const response = await http.put(
      `/agendamento/atualizar/status/${idScheduling}`,
      {
        noteCorrection,
        status,
        inputsCorrection,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async atualizaAgendamentoMonitor({ idMonitor, idScheduling }) {
    const response = await http.put(
      `/agendamento/atualizar/monitor/${idScheduling}`,
      {
        idMonitor,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async cancelaAgendamento({ cancellationScheduling, idScheduling }) {
    const response = await http.put(
      `/agendamento/adm/cancelar/${idScheduling}`,
      {
        cancellationScheduling,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async faltaAgendamento({ idScheduling }) {
    const response = await http.get(
      `/agendamento/atualizar/falta/${idScheduling}`,
      { headers: authHeader() },
    )
    return response.data
  }

  async atualizarPagamento({ statusPay, idScheduling }) {
    const response = await http.put(
      `/agendamento/atualizar/pagamento/${idScheduling}`,
      {
        statusPay,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async getAluno({ idScheduling, idStudent, codeStudent }) {
    const response = await http.get(
      `agendamento/${idScheduling}/aluno/${encodeURIComponent(
        idStudent,
      )}/${encodeURIComponent(codeStudent)}`,
      { headers: authHeader() },
    )
    return response.data
  }

  async updateAluno({
    idScheduling,
    idStudent,
    codeStudent,
    student,
    participation,
  }) {
    const response = await http.put(
      `agendamento/${idScheduling}/aluno/${encodeURIComponent(
        idStudent,
      )}/${encodeURIComponent(codeStudent)}`,
      {
        student,
        participation,
      },
      { headers: authHeader() },
    )
    return response.data
  }

  async deleteAluno({ idScheduling, idStudent, codeStudent }) {
    const response = await http.delete(
      `agendamento/${idScheduling}/aluno/${encodeURIComponent(
        idStudent,
      )}/${encodeURIComponent(codeStudent)}`,
      { headers: authHeader() },
    )
    return response.data
  }

  async downloadAlunosExcel(idScheduling) {
    return http.get(`agendamento/${idScheduling}/alunos/excel`, {
      headers: authHeader(),
      responseType: 'blob',
    })
  }

  async downloadFormulariosAlunosExcel(idScheduling) {
    return http.get(`agendamento/${idScheduling}/alunos/formularios/excel`, {
      headers: authHeader(),
      responseType: 'blob',
    })
  }

  async downloadPesquisaAlunosExcel(idScheduling) {
    return http.get(`agendamento/${idScheduling}/alunos/pesquisa/excel`, {
      headers: authHeader(),
      responseType: 'blob',
    })
  }

  async downloadPesquisaProfessoresExcel(idScheduling) {
    return http.get(
      `agendamento/${idScheduling}/professores/pesquisa/excel`,
      {
        headers: authHeader(),
        responseType: 'blob',
      },
    )
  }

  async getPresencas(idScheduling, params = {}) {
    const response = await http.get(`agendamento/${idScheduling}/presencas`, {
      headers: authHeader(), params, timeout: 15000,
    })
    return response.data
  }

  async registrarPresencaQr(idScheduling, attendanceCodeStudent) {
    const response = await http.post(`agendamento/${idScheduling}/presenca/qr`, {
      attendanceCodeStudent,
    }, { headers: authHeader(), timeout: 15000 })
    return response.data
  }

  async registrarPresencaManual({ idScheduling, idStudent, codeStudent }) {
    const response = await http.post(
      `agendamento/${idScheduling}/aluno/${encodeURIComponent(idStudent)}/${encodeURIComponent(codeStudent)}/presenca`,
      {}, { headers: authHeader(), timeout: 15000 },
    )
    return response.data
  }

  async downloadPdfPresenca(idScheduling) {
    return http.get(`agendamento/${idScheduling}/presenca/pdf`, {
      headers: authHeader(),
      responseType: 'blob',
    })
  }

  async uploadPagamento({ data, idScheduling }) {
    const headersUp = authHeader()
    headersUp['Content-Type'] = 'multipart/form-data'

    console.log(data)
    const response = await http.put(
      `/agendamento/atualizar/comprovante/${idScheduling}`,
      data,
      {
        headers: headersUp,
      },
    )
    return response.data
  }
}

export default new AgendamentoService()
